import React from 'react';
import { AttachFile as AttachFileIcon, CloseRounded, FileCopy, ArrowUpward } from '@material-ui/icons';
import { Button } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';
import showToastMessage from '../../util/showToastMessage';
import { isExxonMobileEmail } from '../Validator';
import { CommonPromptBox } from '../../components/ui';
import { ACCEPT_ATTR, IMAGE_MIME_TYPES } from '../../utils/fileAccept';

const StyledTooltip = styled(ReactTooltip)`
  max-width: 15% !important
`;

const LightChevron = styled.span`
  display: inline-block;
  font-family: 'Segoe UI', Arial, sans-serif;
  font-size: 38px;
  font-weight: 600;
  line-height: 1;
  color: #7f8a96;
  transform: translateX(-1px) translateY(-1px);
  text-shadow: 0 0 1px rgba(109, 116, 131, 0.55);
`;

const PermitAgentInput = ({
  value,
  onChange,
  onEnter,
  textareaRef,
  hasDiscussionStarted,
  uploadAttachment,
  filePreviews,
  removeAttachment,
  context,
  variant = 'default',
  placeholder: placeholderProp,
}: any) => {
  const isHero = variant === 'hero';
  const isLight = variant === 'light';
  const isPermit = variant === 'permit';
  const placeholderText =
    placeholderProp !== undefined && placeholderProp !== ''
      ? placeholderProp
      : hasDiscussionStarted
        ? 'Continue the conversation...'
        : 'What are you wanting to permit?';

  // Drag/drop is handled page-wide by useFileDrop in permit-agent/index.tsx.
  return (
    <div>
      <input
        id="file-input-permit-agent"
        type="file"
        multiple
        accept={ACCEPT_ATTR}
        onChange={uploadAttachment}
        style={{ display: 'none' }}
        disabled={isExxonMobileEmail(context)}
      />
      <div className={ filePreviews && filePreviews.length ? 'd-flex mb-2 overflow-auto' : 'd-none' }>
        {filePreviews && filePreviews.map((file: any, index: number) => {
          return IMAGE_MIME_TYPES.includes(file.type) ? (
            <div className="preview-img mr-1" key={index}>
              <img src={file.preview} alt={file.name} />
              <Button variant="outline-dark" className="close-button" onClick={() => removeAttachment(index)}><CloseRounded /></Button>
            </div>
          ) : (
            <div className="preview-file" key={index}>
              <FileCopy color="primary" />
              <div>
                <p>{ file.name }</p>
                <p>{ file.type }</p>
              </div>
              <Button variant="outline-dark" className="close-button" onClick={() => removeAttachment(index)}><CloseRounded /></Button>
            </div>
          );
        })}
      </div>
      <CommonPromptBox
        value={value}
        onChange={onChange}
        onSubmit={onEnter}
        variant={isPermit ? 'permit' : (isLight ? 'light' : (isHero ? 'hero' : 'glass'))}
        placeholder={placeholderText}
        inputRef={textareaRef}
        autoFocus
        leftSlot={isLight || isPermit ? null : (
          <div className="image-upload">
            <label
              htmlFor="file-input-permit-agent"
              style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', lineHeight: 1, color: '#546170' }}
              className={
                isExxonMobileEmail(context)
                  ? 'text-secondary'
                  : isHero
                    ? 'text-light'
                    : 'text-dark'
              }
              data-tip="This feature is disabled for ExxonMobil. Please contact the Administrator."
              data-for="exxon-permit"
              onClick={() => {
                if (isExxonMobileEmail(context)) {
                  showToastMessage({ type: 'warn', title: 'Warning', description: 'This Feature is disabled for ExxonMobil. Please contact the Administrator.' });
                }
              }}
            >
            <AttachFileIcon style={{ color: '#546170' }} />
            </label>
            { isExxonMobileEmail(context) && <StyledTooltip id="exxon-permit" place="top" effect="solid" /> }
          </div>
        )}
        submitIcon={
          isLight
            ? <LightChevron>&gt;</LightChevron>
            : <ArrowUpward style={{ fontSize: isPermit ? 34 : 22, color: isPermit ? '#0a1412' : undefined }} />
        }
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            e.stopPropagation();
            onEnter();
          }
        }}
      />
    </div>
  );
};

export default PermitAgentInput;
